import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import ProjectStakeholderGroup from '@/diagrams/models/project-stakeholder-group'
import Match from '@/diagrams/models/match'

@Component
export default class EditStakeholderGroup extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({ default: false })
  private archived!: boolean

  private createNode(evt: CreateNodeEvent): ProjectStakeholderGroup {
    const group = new ProjectStakeholderGroup()
    group.projectId = evt.project.id
    return group
  }

  private selectNode(group: ProjectStakeholderGroup, match: Match): ProjectStakeholderGroup {
    group.name = match.name
    if (match.keywords) {
      group.keywords = match.keywords
    }
    return group
  }
}
